import { EmploymentService } from './../../../services/employment/employment.service';
import {Component, Input, OnChanges, Output, EventEmitter, OnInit} from '@angular/core';
import {Validators, FormControl, FormGroup, FormBuilder} from '@angular/forms';
import {Employment} from '../../../models/customer.model';


@Component ({
  selector: 'kv-employment-form',
  templateUrl: 'employmentForm.html'
})

export class EmploymentFormComponent implements OnChanges, OnInit {
  @Output() employmentAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() employmentUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxEmployment: Employment;
  addEditForm: FormGroup;
  fields: any;
  invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private employmentSvc: EmploymentService) {
  }

  ngOnChanges(...args: any[]) {
    this.addEditForm = this.fb.group({
      'name': new FormControl(this.dialogBoxEmployment.name, Validators.compose([Validators.required, Validators.maxLength(255)])),
    });
  }

  ngOnInit() {
    this.employmentSvc.getFields().subscribe(res => {
      this.fields = res;
    });
  }

  saveOrUpdate(dialogBoxEmployment: any): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    let newData = Object.assign({}, this.dialogBoxEmployment, this.addEditForm.value);
    if (newData.id == null) {
      this.employmentAdded.emit(newData);
    } else {
      this.employmentUpdated.emit(newData);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/employment/employmentForm.component.ts